import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../Button';
import classnames from 'classnames/bind';
import { pagePathnames } from '../../pages/page-routes';
import { useRouting } from '../../shared/use-routing';
import styles from './PageContainer.css';

const cx = classnames.bind(styles);

function PageContainer({ className, title, children }) {
    const { buildPath } = useRouting();
    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });

    const renderContent = () => {
        if (Boolean(title)) {
            return (
                <div className={styles.wrapper}>
                    <h1 className={styles.title}>{title}</h1>
                    {children}
                </div>
            );
        }

        return children;
    };

    return (
        <>
            <Button
                iconLeft={{
                    name: 'chevronLeft'
                }}
                link={{
                    to: buildPath(pagePathnames.dashboard)
                }}
                type='secondary'
                label='Go Back to Dashboard'
                className={styles.button}
            />
            <div className={classes}>
                {renderContent()}
            </div>
        </>
    );
}

PageContainer.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
    children: PropTypes.any.isRequired
};

PageContainer.defaultProps = {
    className: ''
};

export {
    PageContainer
};
